import { render, staticRenderFns } from "./LiveDetailPage.vue?vue&type=template&id=45aac942"
import script from "./LiveDetailPage.vue?vue&type=script&lang=js"
export * from "./LiveDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports